import {
  Alert,
  Avatar,
  Box,
  Button,
  IconButton,
  keyframes,
  Snackbar,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Add,
  Favorite,
  FavoriteBorder,
  TurnedIn,
  TurnedInNot
} from "@mui/icons-material";
import AddMod from "../Modals/AddMOD";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentDateMeal,
  setFavorite,
  setLike
} from "../../features/mod/modSlice";
import dayjs from "dayjs";
import {
  selectIsFavorite,
  selectIsLiked,
  selectLoading,
  selectMealData
} from "../../features/mod/modSelectors";
import getInitials from "../../utils/getInitials";
import { convertTextToLink } from "../../utils/getUrlFromText";
import { favoriteMeal, likeMeal } from "../../api/modApi";
import useSignedUrl from "../../utils/useSignedUrl";
import useThemeColor from "../../utils/useTheme";
import { selectCurrentTheme } from "../../features/theme/themeSelectors";
import { useLocation, useNavigate } from "react-router-dom";
import ReferralModal from "../Modals/ReferFriendModal";
import ViewUserMeal from "../Modals/ViewUserMeals";
import useIsMobile from "../Extra/useMobile";
const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const LoadingMessage = () => {
  // Define keyframes animation using inline CSS
  const fadeInAnimation = {
    animation: "fadeIn 2s ease-out"
  };

  const styles = {
    "@keyframes fadeIn": {
      "0%": {
        opacity: 0,
        transform: "translateY(20px)"
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)"
      }
    }
  };

  return (
    <Typography
      mt={3}
      display="flex"
      fontSize={"23px"}
      justifyContent={"center"}
      alignItems={"center"}
      style={fadeInAnimation} // Apply the inline animation style
      sx={styles} // Inline @keyframes with sx (if using MUI)
    >
      🚀 Meal is on its way... 🍝
    </Typography>
  );
};
const Mod = ({
  setOpenSubscriptionModal,
  isViewingUserMealsMod: isViewingUserMeals,
  setIsViewingUserMealsMod: setIsViewingUserMeals
}) => {
  const [isAddingMeal, setIsAddingMeal] = React.useState(false);
  const [openReferModal, setOpenReferModal] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const currentMeal = useSelector(selectMealData);
  const modLoading = useSelector(selectLoading);
  const isLiked = useSelector(selectIsLiked);
  const isFavorite = useSelector(selectIsFavorite);
  const styles = useThemeColor();
  const currentTheme = useSelector(selectCurrentTheme);
  const theme = useTheme(); // Use theme hook to get the theme
  const isInMobile = useIsMobile();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")) || isInMobile; // Correctly access breakpoints
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  const location = useLocation();
  const { is_verified = false } = location.state || {
    is_verified: false
  };

  useEffect(() => {
    localStorage.setItem("lastVisitedRoute", "/");
  }, []);
  React.useEffect(() => {
    if (Boolean(is_verified)) {
      setOpenSubscriptionModal(false);
    } else if (
      !user?.isFailedPayment &&
      !(user?.isAdmin === 1 || ["Coach", "Company"].includes(user?.userType)) &&
      !user?.isSubscriptionActive &&
      (user?.isTrainingFreeTrialExpired || user?.isDiaryFreeTrialExpired)
    ) {
      setOpenSubscriptionModal(true);
    }
  }, [user]);
  useEffect(() => {
    dispatch(getCurrentDateMeal({ currentDate: dayjs().format("YYYY-MM-DD") }));
  }, [dispatch]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    const scrollableElement = document.getElementById("dashboard-main"); // or document.body
    scrollableElement.scrollTo(0, 0);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
    const scrollableElement = document.getElementById("dashboard-main"); // or document.body
    scrollableElement.scrollTo(0, 0);
  };
  const [isLoading, setIsLoading] = useState(false);

  const mealUserImageSrc = useSignedUrl(
    currentMeal?.userData?.[0]?.profilePic ||
      currentMeal?.adminUserData?.[0]?.profilePic,
    process.env.REACT_APP_BACKEND_PROFILE_IMAGE_LOCATION
  );

  const mealImageSrc = useSignedUrl(
    currentMeal?.mealImage,
    process.env.REACT_APP_BACKEND_MEAL_IMAGE_LOCATION
  );
  const [loaded, setLoaded] = useState(false);
  return !(
    user?.isAdmin === 1 || ["Coach", "Company"].includes(user?.userType)
  ) &&
    !user?.isSubscriptionActive &&
    (user?.isTrainingFreeTrialExpired || user?.isDiaryFreeTrialExpired) ? (
    <></>
  ) : Object.keys(isViewingUserMeals).length > 0 ? (
    <ViewUserMeal
      isViewingUserMeals={isViewingUserMeals}
      setIsViewingUserMeals={setIsViewingUserMeals}
    />
  ) : (
    <Box>
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={"success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {isAddingMeal ? (
        <AddMod
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          isAddingMeal={isAddingMeal}
          setIsAddingMeal={setIsAddingMeal}
        />
      ) : (
        <Box
          pb={10}
          sx={{
            padding: isMobile ? "0 0 90px 0" : "20px 20px 40px 32px"
          }}
        >
          <Box
            display="flex"
            gap={"20px"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent="space-between"
            alignItems={isMobile ? "flex-start" : "center"}
          >
            <Box
              display="flex"
              alignItems="center"
              gap="30px"
              sx={{
                ...(isMobile && {
                  width: "100%",
                  padding: "16px 30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  // position: "fixed",
                  zIndex: 1000,
                  background: "#1F2937",
                  color: styles.color // Apply color to the entire box in mobile view
                })
              }}
            >
              <Box display="flex" alignItems="center" gap="10px">
                {/* <Box>
                  {imgSrc ? (
                    <Box
                      component="img"
                      height={54}
                      borderRadius="50%"
                      width={54}
                      src={imgSrc}
                      alt="avatar"
                    />
                  ) : (
                    <Avatar sx={{ width: 40, height: 40 }}>
                      {getInitials(user?.fullName)}
                    </Avatar>
                  )}
                </Box> */}
                <Box>
                  <Typography
                    fontSize={isMobile || isTablet ? "16px" : "30px"}
                    // fontSize={(isMobile || isTablet || isTablet) ? "18px" : "24px"}
                    fontWeight={400}
                    color={isMobile ? "#FCFCFC" : styles.color}
                  >
                    Meal Of The Day (MOD)
                  </Typography>
                  <Typography
                    fontSize={isMobile || isTablet ? "14px" : "24px"}
                    // fontSize={(isMobile || isTablet || isTablet) ? "14px" : "30px"}
                    color={styles.modLabel}
                    fontWeight={isMobile || isTablet ? 600 : 500}
                  >
                    {dayjs().format("D MMM YYYY")}
                  </Typography>
                </Box>
              </Box>
              {!isMobile ? (
                <Box>
                  {/* <Button
                    variant="outlined"
                    onClick={() => setOpenReferModal(true)}
                    sx={{
                      textTransform: "none",
                      color: "#368AD0",
                      borderColor: "#368AD0",
                      mt: 1, // Reduced margin top
                      gap: "8px",
                      borderRadius: "4px",
                      alignSelf: "flex-end" // Align button to the end horizontally
                    }}
                  >
                    Refer a friend
                  </Button> */}
                </Box>
              ) : (
                <Button
                  onClick={() => {
                    setTimeout(() => {
                      setIsLoading(true);
                      setIsAddingMeal(!isAddingMeal);
                      handleScrollToTop();
                    }, 1000);
                  }}
                  sx={{
                    textTransform: "none",
                    background: "#368AD0",
                    color: "#fcfcfc",
                    height: "40px",
                    padding: isMobile ? "7px 12px" : "12px 24px",
                    ...(isMobile && { fontSize: "14px" }),
                    gap: "8px",
                    borderRadius: "4px"
                    // ...(!isAddingMeal && {
                    //   position: "fixed", // Changed from absolute to fixed for better positioning
                    //   display: "flex",
                    //   bottom: 70,
                    //   right: 16, // Add right padding
                    //   zIndex: 1000 // Ensure button stays on top
                    // })
                    // mt: 3 // Make sure it has some margin on top
                  }}
                >
                  <Add
                    sx={{
                      ...(isMobile && {
                        height: "16px",
                        width: "16px"
                      })
                    }}
                  />{" "}
                  Submit MOD
                </Button>
              )}
            </Box>

            {/* For Web view, Submit MOD Button remains here */}
            {!isMobile && (
              <Button
                onClick={() => {
                  setIsAddingMeal(!isAddingMeal);
                }}
                sx={{
                  textTransform: "none",
                  background: "#368AD0",
                  color: "#fcfcfc",
                  height: isTablet ? "60px" : "40px",
                  padding: "12px 24px",
                  gap: "8px",
                  borderRadius: "4px"
                }}
              >
                <Add /> Submit MOD
              </Button>
            )}
          </Box>
          <ReferralModal
            open={openReferModal}
            onClose={() => setOpenReferModal(false)}
          />
          {modLoading ? (
            <LoadingMessage />
          ) : currentMeal?._id ? (
            <Box
              mt={isMobile ? 0 : isTablet ? 0 : 3}
              gap={isMobile || isTablet ? 2 : 4}
              display="flex"
              padding={isMobile || isTablet ? "16px" : ""}
              flexDirection={isMobile || isTablet ? "column" : "row"}
            >
              <Box
                // mt={isMobile || isTablet ? 10 : 0}
                width={isMobile || isTablet ? "100%" : "50%"}
              >
                <Box
                  sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: 3,
                    padding: isMobile || isTablet ? "0 16px" : undefined
                  }}
                >
                  {/* 🎨 Fancy Animated Skeleton Before Image Loads */}
                  {!loaded && (
                    <Box
                      sx={{
                        width: "100%",
                        paddingTop: "56.25%", // Keeps 16:9 aspect ratio
                        // background:
                        //   "linear-gradient(90deg, #f6f6f6, #e0e0e0, #f6f6f6)",
                        backgroundSize: "400% 100%",
                        animation: `${shimmer} 1.8s infinite ease-in-out`,
                        borderRadius: 3,
                        position: "absolute",
                        top: 0,
                        left: 0
                      }}
                    />
                  )}

                  {/* 🖼️ Actual Image with a Smooth Fade-in Effect */}
                  <Box
                    component="img"
                    src={currentMeal?.mealImage}
                    // src={mealImageSrc}
                    alt={loaded ? "meal" : ""}
                    loading="lazy"
                    onLoad={() => setLoaded(true)}
                    onError={() => setLoaded(false)}
                    sx={{
                      width: "100%",
                      display: "block",
                      opacity: loaded ? 1 : 0,
                      transition:
                        "opacity 0.6s ease-in-out, transform 0.3s ease-in-out",
                      transform: loaded ? "scale(1)" : "scale(1.05)", // Slight zoom effect on load
                      borderRadius: 3,
                      "-webkit-user-drag":
                        isMobile || isTablet ? undefined : "none"
                    }}
                  />
                </Box>
              </Box>

              <Box width="100%" mt={isMobile ? "-10px" : 0}>
                <Box
                  display="flex"
                  flexDirection={isMobile || isTablet ? "column" : "row"}
                  gap={isMobile ? "4px" : "20px"}
                  mb={2}
                  alignItems="center"
                >
                  <Typography
                    color={styles.color}
                    fontSize={isMobile || isTablet ? "28px" : "36px"}
                    fontWeight={isMobile || isTablet ? 600 : 500}
                  >
                    {currentMeal?.title}
                  </Typography>
                  <Box display={"flex"} gap={"10px"}>
                    <Box
                      textAlign="center"
                      alignItems={"center"}
                      justifyContent={"left"}
                      display="flex"
                      gap={2}
                      sx={{
                        background:
                          currentTheme === "light"
                            ? "#FEECE6"
                            : styles.modBackgroundBlocks,
                        padding: "8px 16px"
                      }}
                      borderRadius="8px"
                    >
                      <Box>
                        <Typography
                          fontSize="12px"
                          fontWeight={400}
                          color={styles.inputLabelColor}
                        >
                          800g
                        </Typography>
                        <Typography
                          fontSize="24px"
                          fontWeight={600}
                          color="#F6541C"
                        >
                          {currentMeal?.total800Gms || 0}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      alignItems={"center"}
                      justifyContent={"left"}
                      display="flex"
                      gap={2}
                      textAlign="center"
                      sx={{
                        background:
                          currentTheme === "light"
                            ? "#D4E9FC"
                            : styles.modBackgroundBlocks,
                        padding: "8px 16px"
                      }}
                      borderRadius="8px"
                    >
                      <Box>
                        <Typography
                          fontSize="12px"
                          fontWeight={400}
                          color={styles.inputLabelColor}
                        >
                          Protein g
                        </Typography>
                        <Typography
                          fontSize="24px"
                          fontWeight={600}
                          color="#2C75C5"
                        >
                          {currentMeal?.totalProteinGms || 0}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  display={isMobile || isTablet ? "flex" : "block"}
                  alignItems={isMobile || isTablet ? "center" : "flex-start"}
                  justifyContent={
                    isMobile || isTablet ? "space-between" : "flex-start"
                  }
                >
                  <Box
                    display="flex"
                    gap="10px"
                    alignItems="center"
                    onClick={() => {
                      setIsViewingUserMeals({
                        ...currentMeal,
                        createdByAdminUser: currentMeal?.adminUserData?.[0],
                        createdByUser: currentMeal?.userData?.[0]
                      });
                    }}
                  >
                    {currentMeal?.adminUserData?.[0]?.profilePic ||
                    currentMeal?.userData?.[0]?.profilePic ? (
                      <Box
                        component="img"
                        height={40}
                        borderRadius="50%"
                        width={40}
                        src={
                          currentMeal?.userData?.[0]?.profilePic ||
                          currentMeal?.adminUserData?.[0]?.profilePic
                        }
                        alt="avatar"
                      />
                    ) : (
                      <Avatar sx={{ width: 40, height: 40 }}>
                        {getInitials(
                          currentMeal?.adminUserData?.[0]?.name ||
                            currentMeal?.userData?.[0]?.displayName
                        )}
                      </Avatar>
                    )}{" "}
                    <Typography
                      color={styles.color}
                      fontSize="14px"
                      fontWeight={400}
                    >
                      {currentMeal?.adminUserData?.[0]?.name ||
                        currentMeal?.userData?.[0]?.displayName}
                    </Typography>
                  </Box>

                  <Box sx={{ mt: { md: 3 } }} display="flex" gap="10px">
                    <IconButton
                      onClick={async () => {
                        await likeMeal(currentMeal?._id);
                        // await dispatch(
                        //   getCurrentDateMeal({
                        //     currentDate: dayjs().format("YYYY-MM-DD")
                        //   })
                        // );
                        await dispatch(setLike(!isLiked));
                      }}
                      style={{
                        background: isLiked ? "#FF4000" : "transparent",
                        border: isLiked ? "none" : `1px solid ${styles.color}`
                      }}
                      sx={{
                        padding: 2,
                        height: "32px",
                        borderRadius: "4px"
                      }}
                    >
                      {isLiked ? (
                        <Favorite
                          sx={{
                            height: "20px",
                            width: "20px",
                            fill: "#FCFCFC"
                          }}
                        />
                      ) : (
                        <FavoriteBorder
                          sx={{
                            height: "20px",
                            width: "20px",
                            fill: styles.color
                          }}
                        />
                      )}
                      <Typography
                        color={isLiked ? "#FCFCFC" : styles.color}
                        ml={1}
                      >
                        {(isLiked
                          ? currentMeal?.likeCount + 1
                          : currentMeal?.likeCount) || 0}
                      </Typography>
                    </IconButton>
                    <IconButton
                      onClick={async () => {
                        await favoriteMeal(currentMeal?._id);
                        if (!isFavorite) {
                          setSnackbarMessage(
                            "This MOD has been added to your Meal Library Favorites"
                          );
                          setOpenSnackbar(true);
                        }
                        // await dispatch(
                        //   getCurrentDateMeal({
                        //     currentDate: dayjs().format("YYYY-MM-DD")
                        //   })
                        // );
                        await dispatch(setFavorite(!isFavorite));
                      }}
                      style={{
                        background: isFavorite ? "#03B55C" : "transparent",
                        border: isFavorite
                          ? "none"
                          : `1px solid ${styles.color}`
                      }}
                      sx={{
                        height: "32px",
                        borderRadius: "4px"
                      }}
                    >
                      {isFavorite ? (
                        <TurnedIn
                          sx={{
                            height: "20px",
                            width: "20px",
                            fill: "#FCFCFC"
                          }}
                        />
                      ) : (
                        <TurnedInNot
                          sx={{
                            height: "20px",
                            width: "20px",
                            fill: styles.color
                          }}
                        />
                      )}
                    </IconButton>
                  </Box>
                </Box>

                {/* <Box
                  mt={3}
                  height={64}
                  borderRadius={2}
                  display="flex"
                  gap="10px"
                >
                  <Box
                    width={"100%"}
                    alignItems={"center"}
                    justifyContent={"left"}
                    display="flex"
                    gap={2}
                    sx={{
                      background:
                        currentTheme === "light"
                          ? "#FEECE6"
                          : styles.modBackgroundBlocks,
                      padding: "8px 16px"
                    }}
                    borderRadius="8px"
                  >
                    <AppleIcon />
                    <Box>
                      <Typography
                        fontSize="12px"
                        fontWeight={400}
                        color={styles.inputLabelColor}
                      >
                        800g
                      </Typography>
                      <Typography
                        fontSize="24px"
                        fontWeight={600}
                        color="#F6541C"
                      >
                        {currentMeal?.total800Gms || 0}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    width={"100%"}
                    alignItems={"center"}
                    justifyContent={"left"}
                    display="flex"
                    gap={2}
                    sx={{
                      background:
                        currentTheme === "light"
                          ? "#D4E9FC"
                          : styles.modBackgroundBlocks,
                      padding: "8px 16px"
                    }}
                    borderRadius="8px"
                  >
                    <ProteinIcon />
                    <Box>
                      <Typography
                        fontSize="12px"
                        fontWeight={400}
                        color={styles.inputLabelColor}
                      >
                        Protein
                      </Typography>
                      <Typography
                        fontSize="24px"
                        fontWeight={600}
                        color="#2C75C5"
                      >
                        {currentMeal?.totalProteinGms || 0}g
                      </Typography>
                    </Box>
                  </Box>
                </Box> */}

                <Box
                  width={"100%"}
                  sx={{
                    background: styles.modBackgroundBlocks,
                    padding: "12px 16px",
                    color: "#9CA3AF",
                    mt: 3,
                    borderRadius: "8px"
                  }}
                >
                  <Typography
                    color={styles.color}
                    fontSize="16px"
                    fontWeight={600}
                  >
                    Ingredients
                  </Typography>
                  <ul
                    style={{
                      paddingLeft: "18px",
                      margin: 0,
                      marginTop: 15,
                      color: styles.inputLabelColor
                    }}
                  >
                    {currentMeal?.fruitsVeggies?.map((item) => (
                      <li key={item._id}>
                        <Typography variant="body1">
                          {item.quantity
                            ? `${item.quantity} ${item.unit} ${item.name}`
                            : item.name}
                        </Typography>
                      </li>
                    ))}
                    {currentMeal?.protein?.map((item) => (
                      <li key={item._id}>
                        <Typography variant="body1">
                          {item.quantity
                            ? `${item.quantity} ${item.unit} ${item.name}`
                            : item.name}
                        </Typography>
                      </li>
                    ))}
                    {currentMeal?.otherIngredients?.map((item) => (
                      <li key={item._id}>
                        <Typography variant="body1">
                          {item.quantity
                            ? `${item.quantity} ${item.unit} ${item.name}`
                            : item.name}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                </Box>

                {currentMeal?.generalText && (
                  <Box
                    width={"100%"}
                    sx={{
                      background: styles.modBackgroundBlocks,
                      padding: "12px 16px",
                      mt: 3,
                      borderRadius: "8px"
                    }}
                  >
                    <Typography
                      color={styles.color}
                      fontSize="16px"
                      fontWeight={600}
                    >
                      Details
                    </Typography>
                    <Typography
                      mt={2}
                      variant="body1"
                      color={styles.inputLabelColor}
                    >
                      {convertTextToLink(currentMeal?.generalText)}
                    </Typography>
                  </Box>
                )}

                {/* For Mobile, Submit MOD Button at the end */}
              </Box>
            </Box>
          ) : (
            <Box mt={5}>No Meal Scheduled for today</Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default Mod;
